module.exports = __webpack_public_path__ + "img/heart-red.26a45ce9.svg";